import React from 'react'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { BANKING_BOTTOM_CONTENT, SOFTWARE_COURSE_PAGE_1, SOFTWARE_DETAILS_PAGE_1, SOFTWARE_HERO_PAGE_1 } from '../../../utils/constants'
import { SOFTWARE_ACCORDIAN_1 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const SoftwarePage_1 = () => {
  return (
    <div className='outlet-render'>
     <CourseAsideHero  {...SOFTWARE_HERO_PAGE_1}/>
     <CoursesAside {...SOFTWARE_COURSE_PAGE_1}/>
     <CourseCard {...SOFTWARE_DETAILS_PAGE_1}/>
     <Accordian {...SOFTWARE_ACCORDIAN_1}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default SoftwarePage_1